class GridListToggle extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.grid-list-toggle__button');
    this.productGrid = document.querySelector('.product-grid');
    this.init();
  }

  init() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.handleToggle.bind(this));
    });

    // Check for saved preference
    const savedView = localStorage.getItem('gridListView');
    if (savedView === 'list') {
      this.setView('list');
    }
  }

  handleToggle(event) {
    const button = event.currentTarget;
    const view = button.dataset.view;
    this.setView(view);
  }

  setView(view) {
    if (!this.productGrid) return;

    // Update active button
    this.buttons.forEach((button) => {
      if (button.dataset.view === view) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });

    // Update grid class
    if (view === 'list') {
      this.productGrid.classList.add('product-grid--list-view');
      localStorage.setItem('gridListView', 'list');
    } else {
      this.productGrid.classList.remove('product-grid--list-view');
      localStorage.setItem('gridListView', 'grid');
    }
  }
}

customElements.define('grid-list-toggle', GridListToggle);
